export default {"src":"/_next/static/media/certified.5eca1a63.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};